export const getActiveVariant = (variants, variantId) => variants.find((variant) => variant.variantId === variantId);

export const getActiveSize = (sizes) => {
  if (sizes.length === 1) {
    return sizes[0];
  }
  if (sizes.length > 1) {
    const selectedSizeVariant =
      sizes.find((size) => size.status === 'In Stock' || size.bvdInventoryAvailable) || sizes[0];
    return selectedSizeVariant;
  }
  return {};
};

export const mapOriginalStyleboardIds = (styleboardData) => {
  const { products } = styleboardData;

  const subProductIds = products.map(({ subProductId }) => subProductId);
  const variantIds = products.map(({ variantId }) => variantId);

  const skus = products.map(({ variantId, variants, sku: savedSku }) => {
    const activeVariant = variants.find((variant) => variant.variantId === variantId);
    const { sku } = getActiveSize(activeVariant.sizes);

    return savedSku || sku;
  });

  return {
    subProductIds,
    variantIds,
    skus,
  };
};

export const prepareStyleboardSaveData = (styleboardDataIds) => {
  const newSubProductIds = styleboardDataIds.map(({ subProductId }) => subProductId);
  const newVariantIds = styleboardDataIds.map(({ variantId }) => variantId);
  const newSkuIds = styleboardDataIds.map(({ sku }) => sku);

  return {
    subProductIds: newSubProductIds,
    variantIds: newVariantIds,
    skus: newSkuIds,
  };
};

export const getCurrentSkuItem = (activeVariant, currentSku) => {
  const skuItem = activeVariant.sizes.find(({ sku }) => sku === currentSku) || {};

  return {
    nmgPimId: skuItem?.nmgPimId,
    status: skuItem?.status,
    expectedShipDate: skuItem?.expectedShipDate,
  };
};
